
export default {
  data () {
    return {
      dataOld: [
        {
          id: 1,
          img: require('@/assets/img/home-production-01.png'),
          color: ''
        },
        {
          id: 2,
          title: 'Advance Thickboard',
          img: require('@/assets/img/product/thickboard/product-thickboard.png'),
          color: '#F2F2F2'
        },
        {
          id: 3,
          title: "Advance Thinboard",
          img: require('@/assets/img/product/thinboard/product-thinboard.png'),
          color: '#DACBBE'
        },
        {
          id: 4,
          title: 'Advance Colourboard',
          img: require('@/assets/img/product/colourboard/product-colourboard.png'),
          color: screen.width > 1023 ? '#F2F2F2' : '#DACBBE'
        },
        {
          id: 5,
          title: screen.width > 1023 ? 'Advance HMR V70 / V313' : 'Advance HMR',
          img: require('@/assets/img/product/hmr/product-hmr.png'),
          color: screen.width > 1023 ? '#DACBBE' : '#F2F2F2'
        },
        {
          id: 6,
          title: '',
          img: require('@/assets/img/home-production-03.png'),
          color: ''
        },
        {
          id: 7,
          title: '',
          img: require('@/assets/img/home-production-04.png'),
          color: ''
        },
        {
          id: 8,
          title: 'Advance SHDF',
          img: require('@/assets/img/product/shdf/product-shdf.png'),
          color: '#F2F2F2'
        }
      ],
      data: []
    }
  },
  mounted () {
    this.data = this.dataOld
    // window.addEventListener("resize", function () {
    //   this.data = this.dataOld
    // });
  },
  methods: {
    toPage (url) {
      url === 'Advance HMR V70 / V313' ? url = 'Advance HMR' : ''
      if (url) {
        this.$router.push('/products/' + url)
      }
    }
  }
}
